module.exports = __webpack_public_path__ + "img/lk.2840c5d2.svg";